import { render } from "./MyGroupsContent.vue?vue&type=template&id=50dcb768&ts=true"
import script from "./MyGroupsContent.vue?vue&type=script&lang=ts"
export * from "./MyGroupsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__